//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data() {
        return {
            alertColumns: [
                { name: 'rank', label: 'Rank', field: 'rank', sortable: true, align: 'left', autoWidth: true },
                { name: 'text', label: 'Text', field: r => [r.text, r.key], sortable: true, align: 'left', cellType: 'big-small' },
                { name: 'item', label: 'Item', field: this.getItemInfo, sortable: true, align: 'left', cellType: 'big-small' },
                // { name: 'offset', label: 'Offset', field: 'offset', sortable: true, align: 'left', autoWidth: true },
                { name: 'user', label: 'User', field: this.getUserInfo, sortable: true, align: 'left', cellType: 'big-small' },
                { name: 'created', label: 'Created', field: 'created', format: this.formatDateTime, sortable: true, align: 'left' },
                { name: 'status', label: 'Dismissed', field: this.getDismissed, format: this.formatDateTime, sortable: true, align: 'left' },
            ],
            alerts: null,
            fetching: false,
        };
    },

    methods: {
        formatDateTime(timestamp) {
            return $.formatDateTime(timestamp) || '-';
        },
        getItemInfo(row) {
            const item = !row.collName ? null : $.findById($[row.collName], row.itemId);

            switch (row.collName) {
                case 'cases':
                    return [item.code, 'case'];

                case 'vehicles':
                    return [[item.make, item.model, item.rz].filter(v => v).join(' '), 'vozidlo'];

                default:
                    return [row.itemId || '-', ''];
            }
        },
        getUserInfo(row) {
            const user = $.findById($.users, row.userId);

            return [
                [user.firstName, user.lastName].filter(v => v).join(' '),
                this.$t(`fields.users.role.options.${user.role}`),
            ];
        },
        getDismissed(row) {
            return row.status === 'dismissed' ? row.hidden : null;
        },
        async fetchData() {
            try {
                this.fetching = true;

                await $.fetchAll('settings', 'cases', 'users', 'vehicles');

                this.alerts = (await axios('/alerts')).data.sort((a, b) => a.created - b.created);
            } finally {
                this.fetching = false;
            }
        },
    },

    @cancellableFetch
    async mounted() {
        await this.fetchData();
    },
};
